import { useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import AuthLayout from "@/components/layout/AuthLayout";
import { FormAlert } from "@/components/common/Alert";
import { api, errorMessage } from "@/lib/api";

export default function RequestInvitation() {
  const [form, setForm] = useState({ name: "", email: "", note: "" });
  const [done, setDone] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/request-invitation", form);
      setDone(data.message);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      title="Request an invitation"
      subtitle="The hub owner will review your request. Nothing is created until they invite you."
      testid="request-invitation-page"
      footer={<Link to="/signin" className="font-medium text-foreground underline underline-offset-4" data-testid="back-to-signin-link">Back to sign in</Link>}
    >
      {done ? (
        <FormAlert kind="success" testid="request-invitation-success">{done}</FormAlert>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <FormAlert testid="request-invitation-error">{error}</FormAlert>
          <div className="space-y-2">
            <Label htmlFor="name">Your name</Label>
            <Input id="name" value={form.name} onChange={set("name")} maxLength={120} required data-testid="request-invitation-name-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Work email</Label>
            <Input id="email" type="email" value={form.email} onChange={set("email")} required data-testid="request-invitation-email-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="note">Why you need access (optional)</Label>
            <Textarea id="note" value={form.note} onChange={set("note")} maxLength={1000} rows={3} className="rounded-xl" data-testid="request-invitation-note-input" />
          </div>
          <Button type="submit" className="w-full" disabled={busy || !form.name || !form.email} data-testid="request-invitation-submit-button">
            {busy ? "Sending" : "Send request"}
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
